import React from 'react'

import CallCenterIcon from '@react/react-spectrum/Icon/CallCenter'
import CjaIcon from '@react/react-spectrum/Icon/GraphTrend'
import CoverImage from '@react/react-spectrum/Icon/CoverImage'
import CustomerHubIcon from '@react/react-spectrum/Icon/Channel'
import DefaultIcon from '@react/react-spectrum/Icon/Experience'
import ExternalWebsiteIcon from '@react/react-spectrum/Icon/GlobeOutline'
import JourneyTriggerIcon from '@react/react-spectrum/Icon/Workflow'
import LinkIcon from '@react/react-spectrum/Icon/Link'
import MobileIcon from '@react/react-spectrum/Icon/DevicePhone'
import WebIcon from '@react/react-spectrum/Icon/DeviceDesktop'

import CustomerExperienceIcon from './icons/CxApp.svg'
import KioskIcon from './icons/Kiosk.svg'

import './ProjectTypeIcon.scss'

const ICON_MAPPING = {
  mobile: MobileIcon,
  'mobile-v2': MobileIcon,
  'call-center': CallCenterIcon,
  'customer-experience': CustomerExperienceIcon,
  'customer-experience-v2': CustomerExperienceIcon,
  'external-website': ExternalWebsiteIcon,
  'journey-trigger': JourneyTriggerIcon,
  web: WebIcon,
  'web-modular': WebIcon,
  link: LinkIcon,
  cja: CjaIcon,
  kiosk: KioskIcon,
  ssr: CoverImage,
  'customer-hub': CustomerHubIcon,
  'web-social': WebIcon,
}

export default function ProjectTypeIcon({ icon, projectType, size = 'M' }) {
  const Icon = ICON_MAPPING[icon] || ICON_MAPPING[projectType] || DefaultIcon

  return <div className='project-type-icon'>{typeof Icon === 'string' ? <img src={Icon} /> : <Icon size={size} />}</div>
}
